import { getDocumentPathFromOfferSku } from '../util/method-util';

export const didomiConfig = (publicKeyDidomi, productCode, offerSku, documentUrl) => {
  const documentPath = documentUrl ?? (offerSku && getDocumentPathFromOfferSku(offerSku));
  return {
    cookies: {
      group: {
        enabled: true,
        customDomain: 'spb-' + productCode + '.privacy-center.org'
      }
    },
    app: {
      apiKey: publicKeyDidomi,
      privacyPolicyURL: 'https://assurances.spb.eu/documents/' + documentPath + '/CharteConfidentialite.pdf'
    },
    tagManager: {
      provider: 'gtm'
    },
    integrations: {
      vendors: {
        // Setup the integration with Google (ask Didomi to share consent with Google tags)
        google: {
          enable: true,
          eprivacy: true
        }
      },
      refreshOnConsent: true // by default, ads are reloaded after consent is given
    }
  };
};

export enum ConsentType {
  Cookies = 'cookies',
  MeasureContentPerformance = 'measure_content_performance'
}

export const hasConsentForGtm = didomiObject => {
  if (didomiObject) {
    const userStatus = didomiObject.getUserStatus();

    if (userStatus.vendors && userStatus.vendors.consent && userStatus.vendors.consent.enabled) {
      return userStatus.vendors.consent.enabled.findIndex(v => v.startsWith('c:googleana')) > -1;
    } else return false;
  } else return false;
};
// 'cookies', 'measure_content_performance'
export const hasConsentForSPB = (didomiObject, type: ConsentType) => {
  if (!type) return false;

  if (didomiObject) {
    const userStatus = didomiObject.getUserStatus();

    if (userStatus.purposes && userStatus.purposes.consent && userStatus.purposes.consent.enabled) {
      return userStatus.purposes.consent.enabled.findIndex(v => v === type) > -1;
    } else return false;
  } else return false;
};
